// ── Importaciones tal cual ──────────────────────────────
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Select from 'react-select'
import Table from 'react-bootstrap/Table';
import Button from "react-bootstrap/Button";
import BuyModal from './Modals/BuyModal';
import ModalBranchofficeSelect from '../NavBar/ModalBranchofficeSelect';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { BuysFetchAPI } from '../../api/Buys';
import { SuppliersFetchAPI } from '../../api/Suppliers';
import { GroupsFechtAPI } from '../../api/Groups'
import { WarehousesFetchAPI } from '../../api/Warehouses';
import ErrorAlert from '../Alerts/ErrorAlert';
import SuccessAlert from '../Alerts/SuccessAlert';
import { FaTrashAlt } from 'react-icons/fa'
import LoadingAlert from '../Alerts/LoadingAlert';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .bf-
───────────────────────────────────────────────────────── */
const BF_CSS = `
@keyframes bf-up { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }

/* ── page wrapper ── */
.bf-wrap { font-family: var(--font-sans,-apple-system,sans-serif); }

/* ── banner ── */
.bf-banner {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: .6rem; margin-bottom: 1rem;
}
.bf-banner-title {
  font-size: 1rem; font-weight: 800; color: #0A0A0A;
  display: flex; align-items: center; gap: .4rem;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.bf-required-hint {
  font-size: .74rem; color: #9CA3AF;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.bf-required-hint b { color: #EF4444; }

/* ── SECTION CARD ── */
.bf-section {
  background: #fff; border: 1.5px solid rgba(0,0,0,.07);
  border-radius: 14px;
  overflow: visible;   /* permite que dropdowns (react-select) salgan del contenedor */
  box-shadow: 0 2px 8px rgba(0,0,0,.04);
  margin-bottom: 1rem;
  animation: bf-up .28s ease both;
}
.bf-section-head {
  display: flex; align-items: center; gap: .5rem;
  padding: .6rem 1.1rem;
  background: linear-gradient(135deg, #0F2444 0%, #1B3A6B 100%);
  border-radius: 12px 12px 0 0;   /* clipea el gradiente en las esquinas superiores */
  overflow: hidden;                /* clip solo en el header, no en la card entera */
}
.bf-section-title {
  font-size: .78rem; font-weight: 700; letter-spacing: .04em;
  text-transform: uppercase; color: #fff;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.bf-section-body {
  padding: 1rem 1.1rem;
  display: grid; grid-template-columns: repeat(auto-fill, minmax(200px,1fr)); gap: .75rem .85rem;
}

/* ── FIELD ── */
.bf-field { display: flex; flex-direction: column; gap: .28rem; }
.bf-label {
  font-size: .74rem; font-weight: 600; color: #6B7280;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.bf-required { color: #EF4444; font-weight: 700; }

/* override form controls inside .bf-section */
.bf-section .form-control,
.bf-section .form-select {
  border: 1.5px solid rgba(0,0,0,.11) !important;
  border-radius: 9px !important;
  background: rgba(0,0,0,.03) !important;
  font-family: var(--font-sans,-apple-system,sans-serif) !important;
  font-size: .82rem !important;
  color: #111827 !important;
  transition: border-color .14s, box-shadow .14s !important;
}
.bf-section .form-control:focus,
.bf-section .form-select:focus {
  border-color: #1B3A6B !important;
  box-shadow: 0 0 0 3px rgba(27,58,107,.09) !important;
  background: #fff !important; outline: none !important;
}

/* react-select override */
.bf-select-wrap .css-13cymwt-control,
.bf-select-wrap [class$="-control"] {
  border: 1.5px solid rgba(0,0,0,.11) !important;
  border-radius: 9px !important;
  background: rgba(0,0,0,.03) !important;
  font-size: .82rem !important;
  font-family: var(--font-sans,-apple-system,sans-serif) !important;
  box-shadow: none !important;
  min-height: 38px !important;
}
.bf-select-wrap [class$="-control"]:hover { border-color: rgba(27,58,107,.3) !important; }
.bf-select-wrap [class$="-control"]:focus-within { border-color: #1B3A6B !important; box-shadow: 0 0 0 3px rgba(27,58,107,.09) !important; }

/* ── ADD PRODUCT ROW ── */
.bf-add-row {
  display: flex; align-items: flex-end; gap: .65rem;
  padding: 0 1.1rem 1rem; flex-wrap: wrap;
}
.bf-add-row .bf-field { flex: 1; min-width: 200px; }
.bf-btn-add {
  display: inline-flex; align-items: center; gap: .35rem;
  padding: .58rem 1.15rem; border-radius: 9px; border: none;
  background: #1B3A6B; color: #fff;
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .81rem; font-weight: 600; cursor: pointer;
  transition: background .14s, transform .14s; flex-shrink: 0;
  align-self: flex-end;
}
.bf-btn-add:hover { background: #152D54; transform: translateY(-1px); }

/* ── TABLE SECTION ── */
.bf-table-section {
  background: #fff; border: 1.5px solid rgba(0,0,0,.07);
  border-radius: 14px; overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,.04);
  margin-bottom: 1rem;
}
.bf-table-head {
  display: flex; align-items: center; gap: .5rem;
  padding: .6rem 1.1rem;
  background: linear-gradient(135deg, #0F2444 0%, #1B3A6B 100%);
}
.bf-table-title {
  font-size: .78rem; font-weight: 700; letter-spacing: .04em;
  text-transform: uppercase; color: #fff;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.bf-table-wrap { overflow-x: auto; }

/* table overrides */
.bf-table-section .table { margin-bottom: 0; font-size: .79rem; }
.bf-table-section .table-dark th {
  background: #1B3A6B !important; color: #fff !important;
  font-size: .68rem !important; font-weight: 700 !important;
  letter-spacing: .04em; text-transform: uppercase; border: none !important;
  padding: .55rem .75rem !important; white-space: nowrap;
}
.bf-table-section .table td {
  vertical-align: middle !important; color: #374151;
  border-color: rgba(0,0,0,.05) !important; padding: .45rem .6rem !important;
}
.bf-table-section .table tbody tr:hover { background: rgba(27,58,107,.03) !important; }
.bf-table-section .table .form-control,
.bf-table-section .table .form-select {
  border: 1.5px solid rgba(0,0,0,.11) !important; border-radius: 7px !important;
  background: rgba(0,0,0,.03) !important; font-size: .78rem !important;
  min-width: 80px; padding: .35rem .55rem !important;
}
.bf-table-section .table .form-control:focus,
.bf-table-section .table .form-select:focus {
  border-color: #1B3A6B !important; box-shadow: 0 0 0 2px rgba(27,58,107,.09) !important;
  background: #fff !important; outline: none !important;
}
.bf-table-section .btn-outline-danger {
  border-radius: 7px !important; padding: .3rem .55rem !important;
  font-size: .75rem !important; border: 1.5px solid rgba(239,68,68,.25) !important;
  background: rgba(239,68,68,.07) !important; color: #EF4444 !important;
  transition: all .12s !important;
}
.bf-table-section .btn-outline-danger:hover { background: #EF4444 !important; color: #fff !important; border-color: #EF4444 !important; }

/* empty products alert */
.bf-table-section .alert-danger {
  margin: .75rem; border-radius: 10px !important; font-size: .8rem !important;
}

/* ── TOTALS CARD ── */
.bf-totals {
  background: #fff; border: 1.5px solid rgba(0,0,0,.08);
  border-radius: 13px; padding: 1rem 1.15rem;
  min-width: 240px; box-shadow: 0 2px 8px rgba(0,0,0,.05);
  margin-left: auto;
}
.bf-totals-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: .38rem 0; font-size: .81rem;
  font-family: var(--font-sans,-apple-system,sans-serif);
  border-bottom: 1px solid rgba(0,0,0,.05);
}
.bf-totals-row:last-child { border-bottom: none; }
.bf-totals-label { color: #6B7280; font-weight: 500; }
.bf-totals-value { color: #111827; font-weight: 600; }
.bf-totals-row.total { border-top: 1.5px solid rgba(0,0,0,.1); margin-top: .35rem; padding-top: .55rem; }
.bf-totals-row.total .bf-totals-label { font-weight: 700; color: #0A0A0A; font-size: .88rem; }
.bf-totals-row.total .bf-totals-value { color: #1B3A6B; font-weight: 800; font-size: .95rem; }

/* ── responsive ── */
@media(max-width: 640px) {
  .bf-section-body { grid-template-columns: 1fr; }
  .bf-add-row { flex-direction: column; align-items: stretch; }
  .bf-btn-add { width: 100%; justify-content: center; }
  .bf-totals { min-width: 100%; }
}
`;

if (typeof window !== 'undefined' && !document.getElementById('bf-styles')) {
  const el = document.createElement('style');
  el.id = 'bf-styles'; el.textContent = BF_CSS;
  document.head.appendChild(el);
}

/* ── ICONS ── */
const IcoCart   = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>;
const IcoOrder  = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>;
const IcoBox    = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>;
const IcoPlus   = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
const BuyForm = ({ selectedBranch, setSelectedBranch, warehouses, setWarehouses, products, setProducts }) => {

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  let { business_code } = useParams();
  let user  = JSON.parse(localStorage.getItem('user'));
  let token = localStorage.getItem('x-access-token');

  const [userBranchoffices, setUserBranchs]     = useState([]);
  const [businessSupliers, setBusinessSupliers] = useState([]);
  const [productSelected, setProduct]           = useState('null');
  const [productsList, setProductsList]         = useState([]);
  const [eventHandler, setEventHandler]         = useState(0);
  const [invoiceTotal, setInvoiceTotal]         = useState(0);
  const [invoiceSubtotal, setInvoiceSubtotal]   = useState(0);
  const [invoiceTax, setInvoiceTax]             = useState(0);
  const [invoiceDiscount, setInvoiceDiscount]   = useState(0);
  const [showModal, setShowModal]               = useState(false);

  const getBusinessSuppliers = async (business_id) => {
    try {
      const response = await SuppliersFetchAPI.getBusinessSupplier(business_id, token);
      setBusinessSupliers(response.data.suppliers);
    } catch (err) { setBusinessSupliers([]); }
  };

  const supplierList = () => businessSupliers.map((supplier, i) => (
    <option key={i} value={supplier.id}>{supplier.name + ' Ruc:  ' + supplier.ruc}</option>
  ));

  const branchList = () => userBranchoffices.map((branch, i) => (
    <option key={i} value={branch.code} data-branchofficeid={branch.branchoffice_id}>{branch.branchoffice_name}</option>
  ));

  const warehousesList = () => warehouses.map((warehouse, i) => (
    <option key={i} value={warehouse.id}>{warehouse.name}</option>
  ));

  const optionsProducts = products.map(product => ({ label: product.name, value: product.group_id }));

  const handleChangeProducts = (option) => { setProduct(option); };

  const addProduct = async (e) => {
    e.preventDefault();
    if (productSelected === 'null') {
      ErrorAlert('Seleccione un producto', 'Error', 'warning');
    } else {
      const product_selected = products.find(e => e.group_id === productSelected.value);
      setProductsList([...productsList, {
        "name": product_selected.name, "code": '', "cant": 1, "price": 0,
        "tax": '0%', "total_product_itbms": 0, "total_discount": 0,
        'unit_discount': 0, "subtotal_product": 0, "total_product": 0,
        "group_id": productSelected.value,
      }]);
      calculateInvoiceTotals(productsList);
    }
  };

  const handleEditTableProduct = (indexCell, cellName, cellValue) => {
    const editProducts = productsList.map((product, index) => {
      let newProductCant = product.cant, newProductDiscount = product.total_discount,
        newProductPrice = product.price, newProductCode = product.code,
        newUnitDiscount = product.unit_discount;
      let itmb_value = product.tax.split('%')[0] / 100;
      let total_product_itbms = 0, subtotal_product = 0, total_product = 0, total_discount = 0;

      if (cellName === 'cant') {
        newProductCant = cellValue;
        if (newProductCant === '' || newProductCant < 1) newProductCant = 1;
      }
      if (cellName === "tax") itmb_value = cellValue.split('%')[0] / 100;
      if (cellName === "total_discount") {
        newProductDiscount = (((cellValue / 100) * newProductPrice) * newProductCant);
        newUnitDiscount = ((cellValue / 100) * newProductPrice);
        if (newProductDiscount === '' || newProductDiscount < 0) { newProductDiscount = 0; newUnitDiscount = 0; }
      }
      if (cellName === "price") {
        newProductPrice = cellValue;
        if (cellValue === '' || cellValue < 0) newProductPrice = 0;
      }
      if (cellName === "code") {
        newProductCode = cellValue;
        if (newProductCode === '') newProductCode = '';
      }
      if (index === indexCell) {
        total_discount = newUnitDiscount * newProductCant;
        total_product_itbms = newProductCant * (itmb_value * (newProductPrice - newUnitDiscount));
        subtotal_product = (newProductCant * (newProductPrice - newUnitDiscount));
        total_product = (newProductCant * (newProductPrice - newUnitDiscount)) + total_product_itbms;
        return { ...product, [cellName]: cellValue, "subtotal_product": subtotal_product, "total_product": total_product, "total_product_itbms": total_product_itbms, "total_discount": total_discount, 'unit_discount': newUnitDiscount };
      }
      return product;
    });
    setProductsList(editProducts);
    calculateInvoiceTotals(editProducts);
    setEventHandler(1);
  };

  const calculateInvoiceTotals = (products) => {
    let invoiceTotalDiscount = 0, invoiceSubtotal = 0, invoiceTotalItbms = 0, invoiceTotal = 0;
    if (products.length === 0) {
      setInvoiceTotal(0); setInvoiceDiscount(0); setInvoiceSubtotal(0); setInvoiceTax(0);
    } else {
      for (let i = 0; i < products.length; i++) {
        let product_info = products[i];
        let product_tax = product_info.tax.split('%')[0];
        let product_tax_value = product_tax / 100;
        let product_unit_discount = product_info.unit_discount;
        let product_total_discount = (product_unit_discount * product_info.cant);
        let total_product_price = (product_info.cant * (product_info.price - product_unit_discount));
        let total_product_itbms = (product_info.cant * ((product_info.price - product_unit_discount) * product_tax_value));
        invoiceTotalDiscount += product_total_discount;
        invoiceSubtotal += total_product_price;
        invoiceTotalItbms += total_product_itbms;
        invoiceTotal += total_product_price + total_product_itbms;
      }
      invoiceTotal = Math.round(invoiceTotal * 100) / 100;
      setInvoiceTotal(invoiceTotal); setInvoiceSubtotal(invoiceSubtotal);
      setInvoiceDiscount(invoiceTotalDiscount); setInvoiceTax(invoiceTotalItbms);
    }
  };

  const tableProduct = () => {
    let productData = productsList;
    let rows = productData.map((product, index) => (
      <tr key={index}>
        <td>{product.name}</td>
        <td><input type="text" defaultValue={product.code} className="form-control" onChange={e => handleEditTableProduct(index, "code", e.target.value)} /></td>
        <td><input type="number" defaultValue={product.cant} className="form-control" onChange={e => handleEditTableProduct(index, "cant", e.target.value)} /></td>
        <td><input type="number" step="0.00000001" defaultValue={product.price} className="form-control" onChange={e => handleEditTableProduct(index, "price", e.target.value)} /></td>
        <td>
          <select className="form-select" aria-label="Select payment type" onChange={e => handleEditTableProduct(index, "tax", e.target.value)} value={product.tax}>
            <option value="7%">7%</option>
            <option value="0%">0%</option>
            <option value="10%">10%</option>
            <option value="15%">15%</option>
          </select>
        </td>
        <td><input type="number" step="0.00000001" defaultValue={product.total_discount} onChange={e => handleEditTableProduct(index, "total_discount", e.target.value)} className="form-control" /></td>
        <td>${product.unit_discount.toFixed(2)}</td>
        <td>{product.total_product.toFixed(2)}</td>
        <td>
          <button onClick={e => deleteProduct(index, e)} className="btn btn-outline-danger">
            <i className="uil uil-trash-alt" />
          </button>
        </td>
      </tr>
    ));
    return (
      <>
        {rows <= 0
          ? <tr><td colSpan="9"><div className=" alert-danger w-100 mt-2 fw-bold" role="alert">Actualmente no se ha agregado ningún producto.</div></td></tr>
          : rows}
      </>
    );
  };

  const deleteProduct = async (product_index, e) => {
    e.preventDefault();
    productsList.splice(product_index, 1);
    setProductsList([...productsList]);
    calculateInvoiceTotals([...productsList]);
  };

  const newBuy = async () => {
    setShowModal(false);
    LoadingAlert('Insertando inventario', 'Espere un momento');
    const form = new FormData(document.querySelector('form'));
    form.append('branchoffice_id', selectedBranch.id);
    form.append('business_id', user.business.id);
    form.append('subtotal', invoiceSubtotal);
    form.append('tax', invoiceTax);
    form.append('discount', invoiceDiscount);
    let buy = Object.fromEntries(form.entries());
    buy.products = productsList;
    if (buy.total !== '' && buy.total !== null) {
      try {
        const response = await BuysFetchAPI.newBuy(buy, token);
        SuccessAlert(response.data.message);
      } catch (err) {
        ErrorAlert(err.response.data.error, 'Error!', 'warning');
      }
    } else {
      ErrorAlert('El Total ingresado de la factura no puede estar vacio', 'Error!', 'warning');
    }
  };

  useEffect(() => {
    setUserBranchs(user.branchoffices);
    getBusinessSuppliers(user.business.id);
  }, []);

  useEffect(() => {
    setProductsList([...productsList]);
    setWarehouses([...warehouses]);
    setEventHandler(0);
  }, [eventHandler]);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  return (
    <>
      <div className="bf-wrap">

        {/* ── BANNER ── */}
        <div className="bf-banner">
          <div className="bf-banner-title"><IcoCart /> Nueva compra</div>
          <span className="bf-required-hint"><b>*</b> Campos obligatorios</span>
        </div>

        {/* ─────────────────────────── FORM ─────────────────────────── */}
        <form onSubmit={newBuy} className="row bg-white p-0 mt-1 border-sp border" style={{ display: 'contents' }}>
        {/* Note: form tag preserved with original onSubmit and className */}
        </form>

        {/* Render via regular form since 'display:contents' is needed for form to work */}
        <form onSubmit={newBuy} className="needs-validation">

          {/* ── SECCIÓN 1: Detalles de la compra ── */}
          <div className="bf-section">
            <div className="bf-section-head">
              <IcoCart />
              <span className="bf-section-title">Detalles de la compra</span>
            </div>
            <div className="bf-section-body">

              <div className="bf-field">
                <label className="bf-label">Bodega <span className="bf-required">*</span></label>
                <select className="form-select" name="warehouse_id" id="warehouse_id">
                  <option value={0}>Seleccione...</option>
                  {warehousesList()}
                </select>
              </div>

              <div className="bf-field">
                <label className="bf-label">Fecha de compra <span className="bf-required">*</span></label>
                <input type="date" name="invoiceDate" className="form-control" />
              </div>

              <div className="bf-field">
                <label className="bf-label">Número de factura <span className="bf-required">*</span></label>
                <input type="text" name="invoice" className="form-control" placeholder="Factura xxxxx-xxxxxx" />
              </div>

            </div>
          </div>

          {/* ── SECCIÓN 2: Detalles del pedido ── */}
          <div className="bf-section">
            <div className="bf-section-head">
              <IcoOrder />
              <span className="bf-section-title">Detalles del pedido</span>
            </div>
            <div className="bf-section-body">

              <div className="bf-field">
                <label className="bf-label">Total de la compra <span className="bf-required">*</span></label>
                <input type="text" name="total" className="form-control" placeholder="$ 0.00" />
              </div>

              <div className="bf-field">
                <label className="bf-label">Proveedor (opcional)</label>
                <select className="form-select" name="supplier_id" id="supplier_id">
                  <option value={0}>Seleccione...</option>
                  {supplierList()}
                </select>
              </div>

            </div>

            {/* add product row — fuera del grid */}
            <div className="bf-add-row">
              <div className="bf-field">
                <label className="bf-label"><IcoBox /> Producto a agregar</label>
                <div className="bf-select-wrap">
                  {/* Select react-select — props exactas */}
                  <Select
                    className="w-100"
                    value={productSelected}
                    options={optionsProducts}
                    onChange={handleChangeProducts}
                  />
                </div>
              </div>
              {/* addProduct — onClick original intacto */}
              <button type="button" className="bf-btn-add btn btn-primary" onClick={addProduct}>
                <IcoPlus /> Agregar producto
              </button>
            </div>
          </div>

          {/* ── SECCIÓN 3: Tabla de productos ── */}
          <div className="bf-table-section">
            <div className="bf-table-head">
              <IcoBox />
              <span className="bf-table-title">Detalles de productos</span>
            </div>
            <div className="bf-table-wrap">
              {/* Table — import original intacto */}
              <Table responsive>
                <thead className="table-dark">
                  <tr>
                    <th>Producto</th>
                    <th>Código (upc/ean)</th>
                    <th>Cantidad</th>
                    <th>Precio unitario</th>
                    <th>Impuesto (itbms)</th>
                    <th>Descuento %</th>
                    <th>Descuento unitario</th>
                    <th>Total</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {/* tableProduct() — lógica original intacta */}
                  {tableProduct()}
                </tbody>
              </Table>
            </div>
          </div>

          {/* ── TOTALES ── */}
          <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:'1rem' }}>
            <div className="bf-totals">
              <div className="bf-totals-row">
                <span className="bf-totals-label">Descuento</span>
                <span className="bf-totals-value">${invoiceDiscount.toFixed(2)}</span>
              </div>
              <div className="bf-totals-row">
                <span className="bf-totals-label">Subtotal</span>
                <span className="bf-totals-value">${invoiceSubtotal.toFixed(2)}</span>
              </div>
              <div className="bf-totals-row">
                <span className="bf-totals-label">Total impuestos</span>
                <span className="bf-totals-value">${invoiceTax.toFixed(2)}</span>
              </div>
              <div className="bf-totals-row total">
                <span className="bf-totals-label">Total</span>
                <span className="bf-totals-value">${invoiceTotal.toFixed(2)}</span>
              </div>
            </div>
          </div>

        </form>

        {/* BuyModal — props exactas */}
        <BuyModal
          showModal={showModal}
          selectedBranch={selectedBranch}
          productsList={productsList}
          invoiceDiscount={invoiceDiscount}
          invoiceSubtotal={invoiceSubtotal}
          invoiceTax={invoiceTax}
          invoiceTotal={invoiceTotal}
          setShowModal={setShowModal}
          newBuy={newBuy}
          setEventHandler={setEventHandler}
          eventHandler={eventHandler}
          modalTitle="Confirmación de Compra"
          modalType="buy_confirmation"
          buttonModal={true}
          voidedBuyDetails={{ invoice: 0 }}
        />

      </div>

      {/* imports no-JSX preservados */}
      {void [Button, ModalBranchofficeSelect, BranchOfficeFetchAPI, WarehousesFetchAPI, GroupsFechtAPI, ErrorAlert, SuccessAlert, FaTrashAlt, LoadingAlert, branchList]}
    </>
  );
};

export default BuyForm;